import { ChangeDetectorRef, Component, Inject, NgZone, OnInit, Renderer2, signal, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EnpsComponent } from '@common/components/base/enps-component';
import { DataStore } from '@common/data-models/data-store/data-store';
import { UsersResults } from '@common/data-models/search-results/users-result';
import { UserStaffInfo } from '@common/data-models/service/user-staff-info';
import { GlobalTablesService } from '@common/services/global-tables-service';
import { LanguageSettings } from '@common/services/language-settings';
import { NomWebServicesJson } from '@common/services/nom-web-services-json';
import { TeamMembersService } from '@common/services/team-members-service';
import { GlobalRoles, InvitationStatusCodes } from '@common/utils/util';
import { ModalService } from '@src/suite/common/components/modal/modal.service';
import { UserGroup } from '@src/suite/common/data-models/search-results/result-group';
import { AppService } from '@suite/app.service';

@Component({
    selector: 'st-add-team-member',
    templateUrl: './add-team-member.html',
    styleUrls: ['./add-team-member.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-add-team-member',
    },
})
export class AddTeamMemberComponent extends EnpsComponent implements OnInit {
    public newUser: UserStaffInfo = new UserStaffInfo();
    public newUserCurrentRole;
    public InvitationStatusCodes: any = InvitationStatusCodes;
    internalProgramFormControl: FormControl = new FormControl(null);
    internalRoleFormControl: FormControl = new FormControl(null);
    internalStatusFormControl: FormControl = new FormControl(null);
    loading = signal(false);

    constructor(
        public appService: AppService,
        private modalService: ModalService,
        ngZone: NgZone,
        public changeDetectorRef: ChangeDetectorRef,
        public globalTablesService: GlobalTablesService,
        public nomWebServicesJson: NomWebServicesJson,
        public languageSettings: LanguageSettings,
        public teamMembersService: TeamMembersService,
        renderer: Renderer2,
        public dialogRef: MatDialogRef<AddTeamMemberComponent>,
        @Inject(MAT_DIALOG_DATA) public inputData: any
    ) {
        super();
    }

    public get userGroups(): { [id: string]: UserGroup<UserStaffInfo> } {
        return DataStore.usersResults.usersGroups;
    }

    public get disabled(): boolean {
        const disabled: boolean =
            !this.newUser.UserID.trim() || !this.newUser.GivenName.trim() || !this.newUser.Surname.trim() || !this.newUser.Program.trim() || !this.newUser.Active || !this.newUserCurrentRole;
        return disabled;
    }

    public get newUsers(): Array<UserStaffInfo> {
        return DataStore.usersResults.newUsers;
    }

    ngOnInit() {
        this.internalProgramFormControl.markAsTouched();
        this.internalRoleFormControl.markAsTouched();
        this.internalStatusFormControl.markAsTouched();
        this.changeDetectorRef.detectChanges();
    }

    public newUserSelectRole() {
        if (this.newUserCurrentRole) {
            if (this.newUserCurrentRole.ID === GlobalRoles.SUPERVISOR_ID) {
                this.newUser.Supervisor = true;
            } else {
                this.newUser.Supervisor = false;
                this.newUser.ServerManager = false;
            }
            this.newUser.GlobalRole = this.newUserCurrentRole.ID;
        } else {
            this.newUserCurrentRole = null;
        }
    }

    public async addUser() {
        if (!this.disabled) {
            this.loading.set(true);
            try {
                // Check if user already exists
                if (!DataStore.usersResults.checkUserExists(this.newUser.UserID)) {
                    this.newUser.UserID = this.newUser.UserID.trim();
                    this.newUser.GivenName = this.newUser.GivenName.trim();
                    this.newUser.Surname = this.newUser.Surname.trim();
                    this.newUser.Email = this.newUser.Email.trim();
                    this.newUser.SSOLogins = this.newUser.SSOLogins.trim();
                    const res = await this.teamMembersService.createTeamMember(this.newUser);
                    if (res.status) {
                        const userToAdd = Object.assign(new UserStaffInfo(), res.data);
                        DataStore.usersResults.addUser(userToAdd);
                        DataStore.usersResults.rebuildGroups(UsersResults.groupByField, UsersResults.sortByField);
                        this.newUser = new UserStaffInfo();
                        this.newUserCurrentRole = null;
                        this.newUser.Active = null;
                    }
                    this.dialogRef.close();
                } else {
                    this.modalService.openAlert('Add user', `User with ID "${this.newUser.UserID.toUpperCase()}" already exists!`, 'Ok');
                }
            } catch (e) {
                console.log(e);
            }

            setTimeout(() => {
                this.loading.set(false);
            }, 1000);
        }
    }

    public cancelNew() {
        this.dialogRef.close();
    }

    public onNewUserChanged(event: any, prop: string) {
        this.newUser[prop] = event;
    }
}
